export const DAILY_LOG_STEPS = ["Overview", "Workforce", "Equipment", "MilestoneReport", "SitePicture"] as const;

export type DailyLogStep = (typeof DAILY_LOG_STEPS)[number];

export const STEP_TITLES: Record<DailyLogStep, string> = {
  Overview: "Overview",
  Workforce: "Workforce",
  Equipment: "Equipment",
  MilestoneReport: "Milestone Report",
  SitePicture: "Site Picture",
};

export const MILESTONE_REPORT_CHIPS = [
  {
    id: "1",
    name: "Work details",
  },
  {
    id: "2",
    name: "Materials used",
  },
  {
    id: "3",
    name: "Issues encountered",
  },
  {
    id: "4",
    name: "Client feedback",
  },
  {
    id: "5",
    name: "Impact on schedule",
  },
  {
    id: "6",
    name: "Upcoming plans",
  },
  {
    id: "7",
    name: "Overall progress",
  },
] as const;
